module.exports = __webpack_public_path__ + "static/media/preview.ec462234.png";